import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllServices, Service, getRegularServices } from '../services/contentService';

const FALLBACK_PRODUCTS: Service[] = [
  { id: 1, name: 'Vestidos', description: 'Confección de todo tipo de vestidos a tu medida', price: 'Desde $500', icon: '👗', gradient: 'from-pink-500/20 to-rose-500/20', border_color: 'hover:border-pink-300/50', sort_order: 1, is_active: true },
  { id: 2, name: 'Conjuntos de Cocina', description: 'Delantales y accesorios personalizados', price: 'Desde $450', icon: '👩‍🍳', gradient: 'from-amber-500/20 to-orange-500/20', border_color: 'hover:border-amber-300/50', sort_order: 2, is_active: true },
  { id: 3, name: 'Ropa de Cama', description: 'Sábanas, fundas y cobertores a medida', price: 'Desde $800', icon: '🛏️', gradient: 'from-sky-500/20 to-blue-500/20', border_color: 'hover:border-sky-300/50', sort_order: 3, is_active: true },
  { id: 4, name: 'Cortinas', description: 'Para cualquier espacio de tu hogar', price: 'Desde $600', icon: '🪟', gradient: 'from-emerald-500/20 to-teal-500/20', border_color: 'hover:border-emerald-300/50', sort_order: 4, is_active: true },
  { id: 5, name: 'Reparaciones', description: 'Ajustes y arreglos de prendas', price: 'Desde $100', icon: '✂️', gradient: 'from-violet-500/20 to-purple-500/20', border_color: 'hover:border-violet-300/50', sort_order: 5, is_active: true },
  { id: 6, name: 'Trajes Folklóricos', description: 'Diseños tradicionales mexicanos', price: 'Desde $1,800', icon: '💃', gradient: 'from-rose-500/20 to-fuchsia-500/20', border_color: 'hover:border-rose-300/50', sort_order: 6, is_active: true },
];

const ProductosPage: React.FC = () => {
  const [products, setProducts] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const services = await getAllServices();
        const regularServices = services.filter(s => !s.metadata || !s.metadata.includes('"type":"custom"'));
        setProducts(regularServices);
      } catch (error) {
        console.error('Error loading products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const displayProducts = products.length > 0 ? products : FALLBACK_PRODUCTS;

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-600"></div>
      </div>
    );
  }

  return (
    <div className="relative">
      {/* Page Header */}
      <section className="relative overflow-hidden py-16 md:py-20">
        <div className="absolute inset-0 bg-gradient-to-br from-pink-50 via-white to-purple-50/50" />
        <div className="absolute top-10 right-10 w-48 h-48 bg-pink-400/10 rounded-full blur-[80px]" />
        <div className="absolute bottom-10 left-10 w-64 h-64 bg-purple-400/10 rounded-full blur-[80px]" />
        
        <div className="container-custom relative text-center">
          <h3 className="text-sm font-semibold uppercase tracking-widest text-pink-500 mb-3 animate-fade-in">Catálogo</h3>
          <h1 className="text-4xl md:text-5xl font-bold font-display text-gray-900 mb-4 animate-slide-up">
            Nuestros Productos
          </h1>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto animate-slide-up-delayed">
            Explora nuestra colección de productos hechos a mano con la mejor calidad
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12 pb-20">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 stagger-children">
            {displayProducts.map((product, idx) => (
              <div 
                key={product.id} 
                className={`group relative bg-white/60 backdrop-blur-sm rounded-2xl border border-white/50 ${product.border_color || 'hover:border-pink-300/50'} p-8 hover:shadow-xl hover:shadow-pink-500/5 hover:-translate-y-2 transition-all duration-500 glow-hover`}
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${product.gradient || 'from-pink-500/20 to-rose-500/20'} rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
                <div className="relative text-center">
                  <div className="text-5xl mb-5 transform group-hover:scale-110 transition-transform duration-300">
                    {product.icon || '🛍️'}
                  </div>
                  <h3 className="font-bold text-xl mb-2 text-gray-900">{product.name}</h3>
                  <p className="text-gray-500 mb-4 leading-relaxed">{product.description}</p>
                  <p className="text-pink-600 font-bold text-lg mb-5">{product.price}</p>
                  <Link 
                    to="/contacto" 
                    className="inline-flex items-center px-5 py-2.5 bg-gradient-to-r from-pink-500 to-pink-600 text-white rounded-xl text-sm font-medium shadow-lg shadow-pink-500/20 hover:shadow-xl hover:shadow-pink-500/30 hover:-translate-y-0.5 transition-all duration-300"
                  >
                    Cotizar
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductosPage;